import instance from "@/services/api";

export const attorneysAPI = {
  async getList() {
    return await instance().get('/common/attorneys/').then(res => res?.data)
  },
  async uploadAttorney(formData) {
    return await instance().post('/common/attorneys/', formData, {
      headers: {
        "Content-Type": "multipart/form-data"
      }
    }).then(res => res?.data)
  },
  async deleteAttorney(attorneyId) {
    return await instance().delete(`/common/attorneys/${attorneyId}/`).then(res => res?.data)
  },
}

